module.exports = __webpack_public_path__ + "static/tyler-02bf54307a9ffa89426473ea66e0cb20.png";